import logger from '~/services/logger';
import {
  getTabScrollPx,
  getCanScrollLeft,
  getCanScrollRight,
} from './get-tab-scroll-px';

/**
 * Triggers the scroll action for tabs based on direction and configuration
 * Similar to horizontal list triggerScrollAction but adapted for tabs
 * @param ref - The tab container ref
 * @param gutter - The horizontal gutter between tabs
 * @param paddingLeft - Left padding of the tab container
 * @param paddingRight - Right padding of the tab container
 * @param componentMaxWidth - Maximum width of the component
 * @param tabItemSize - The tab item size configuration
 * @param direction - The direction of the scroll action
 */
export function triggerTabScrollAction({
  ref,
  gutter,
  paddingLeft,
  paddingRight,
  componentMaxWidth,
  tabItemSize,
  direction,
}: {
  ref: any;
  gutter: number;
  paddingLeft: number;
  paddingRight: number;
  componentMaxWidth: number | undefined;
  tabItemSize: string;
  direction: 'left' | 'right';
}) {
  if (direction !== 'left' && direction !== 'right') {
    logger.info(`Error: Invalid direction: ${direction}`);
    return;
  }

  if (!ref?.current) return;

  if (direction === 'left' && !getCanScrollLeft({ ref })) return;

  if (direction === 'right' && !getCanScrollRight({ ref })) return;

  const scrollAmount = getTabScrollPx({
    gutter,
    paddingLeft,
    paddingRight,
    componentMaxWidth,
    ref,
    tabItemSize,
  });

  const scrollDirection = direction === 'left' ? -scrollAmount : scrollAmount;

  ref.current.scrollBy({
    left: scrollDirection,
    behavior: 'smooth',
  });
}
